import { gql, useMutation } from '@apollo/client';
import { useLogger } from '@amzn/xb-hooks';
import { SAVE_ILT_EVALUTION_RESPONSE_ERROR } from '../../common/rumMetrics';

export const SAVE_ILT_EVALUATION_RESPONSE = gql`
    mutation saveIltEvaluationResponse($transcriptId: ID!, $evaluationResponseId: ID!) {
        saveIltEvaluationResponse(transcriptId: $transcriptId, evaluationResponseId: $evaluationResponseId) {
            transcriptId
        }
    }
`;

export const useSaveIltEvaluationResponse = (transcriptId: string, evaluationResponseId: string) => {
    const { log, count } = useLogger();
    return useMutation(SAVE_ILT_EVALUATION_RESPONSE, {
        variables: { transcriptId: transcriptId, evaluationResponseId: evaluationResponseId },
        onError: (error) => {
            log.error('Error saving evaluation response', error);
            count(SAVE_ILT_EVALUTION_RESPONSE_ERROR);
        },
    });
};
